import PropTypes from "prop-types";
import React, { Component } from "react";
import { Card, CardTitle, CardText, DialogContainer, ExpansionList, ExpansionPanel } from "react-md";

class PhotoWrapper extends Component {
    constructor(){
        super();
        this.show = this.show.bind(this);
        this.hide = this.hide.bind(this);

        this.state = {
            visible: false
        };
    }

    show(){
        this.setState({visible: true});
    }

    hide(){
        this.setState({visible: false});    
    }

    render(){
        return (
            <div className="PhotoWrapper">
                <Card 
                    className="md-block-centered" 
                    onClick={this.show} 
                    style={{cursor: "zoom-in", marginRight: "2px"}}>
                    <CardTitle 
                        style={{fontSize: 12}} 
                        title={`Photo ${this.props.number}`} 
                    />
                    <CardText>
                        <div className="PhotoContainer">
                            <img src={this.props.src} /> 
                        </div>
                    </CardText>
                </Card>
                <ExpansionList className="md-cell md-cell--12">
                    <ExpansionPanel 
                        label="Photo Tags" 
                        footer={null} 
                        defaultExpanded={this.props.tags ? this.props.tags.length > 0 : false}>
                        {this.props.tags}
                    </ExpansionPanel>
                    <ExpansionPanel 
                        label="Description" 
                        footer={null}>
                        {this.props.desc}
                    </ExpansionPanel>
                </ExpansionList>
                <DialogContainer
                    id="case-photo-dialog"
                    visible={this.state.visible}
                    title={this.props.tags ? this.props.tags : ""}
                    focusOnMount={false}
                    onHide={this.hide} 
                    height="auto"
                    width="auto">  
                    <img src={this.props.src} />        
                </DialogContainer>
            </div>
        );
    }
}

PhotoWrapper.propTypes = {
    src: PropTypes.string.isRequired,
    tags: PropTypes.string,
    desc: PropTypes.string,
    number: PropTypes.number
};

export default PhotoWrapper;
